import React from 'react'
import { observer } from 'mobx-react'
import scrollToTop from 'decorators/scrollToTop'
import LinkedAccountsManager from 'components/LinkedAccountsManager'
import './styles.sass'

@scrollToTop
@observer
export default class LinkAccountsStep extends React.Component {
  componentWillMount () {
    this.props.step.wizard.rootStore.linkedAccountsManager.loadAccounts()
  }

  render () {
    const { step } = this.props
    return (
      <div className="link-accounts-step">
        <LinkedAccountsManager
          manager={step.wizard.rootStore.linkedAccountsManager}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/LinkAccounts/index.jsx